import { Box, Button, TextField, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import dayjs from "dayjs";
import React, { useCallback, useContext, useEffect } from "react";
import { useMemo } from "react";
import { useState } from "react";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { addIdForDataGrid } from "utils";
import { columns } from "./columns";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import ComboBox from "components/ComboBox";
import { jobOrderColNm } from 'constants/jobOrderConstant';
import DateTimeSelect from 'components/DateTimeSelect/DateTimeSelect';
import DataTableDialog from "./DataTableDialog";
import { invoiceColNm } from "constants/invoiceConstant";
import { branchApiNm } from "branch/constant/branchApiNm";
import ClearButton from "components/buttons/ClearButton";
import CheckboxFormControl from "components/CheckboxFormControl";
import { DesktopDatePicker } from "@mui/x-date-pickers-pro";

// const initFilterData = {
//   CusId: null,
//   AptTmSt: dayjs().add(-1, "month").format("YYYY-MM-01 00:00:00"),
//   AptTmEn: dayjs().add(-1, "month").endOf("month").format("YYYY-MM-DD 23:59:59.997")
// }

const clearFilterData = {
  CusId: null,
  JobId: null,
  Loc: null,
  AptTmSt: null,
  AptTmEn: null,
  InvDteSt: null,
  InvDteEn: null,
  JobNo: null,
  ContNo: null,
  DrvId: null,
  SalDte: null,
  IsFilterSalDte: 0
}
const initFilterData = {
  ...clearFilterData,
  AptTmSt: dayjs().format("YYYY-MM-01 00:00:00"),
  AptTmEn: dayjs().format("YYYY-MM-DD 23:59:59.997"),

}
let mode = "INV"
let dialogDataTable = []
const JobOrderAllDetail = () => {

  const { ax, msData } = useContext(GlobalStateContext)

  const [filterData, setFilterData] = useState(initFilterData)
  const [jobCombo, setJobCombo] = useState(msData.jobCombo)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)

  const getData = useCallback((filterData) => {
    const postData = {
      ...filterData,
      SalDte: filterData.IsFilterSalDte ? filterData.SalDte ? dayjs(filterData.SalDte).format("YYYY-MM-01") : null : null
    }
    ax.post(branchApiNm.getJobOrderAllDetail, postData).then(value => {
      if (value.data) {
        for (const row of value.data) {
          // if(row.Exps && row.Exps.length > 0){
          //   row.Trns = row.Exps.find(exp=>exp.ExpId === 1)?.Total  || 0
          //   row.LiftF = row.Exps.find(exp=>exp.ExpId === 2)?.Total  || 0
          //   row.LiftE = row.Exps.find(exp=>exp.ExpId === 3)?.Total  || 0
          //   row.PortPass = row.Exps.find(exp=>exp.ExpId === 4)?.Total  || 0
          //   row.DeptPass = row.Exps.find(exp=>exp.ExpId === 5)?.Total  || 0
          //   row.OthCusRcpt = row.Exps.reduce((prev, cur)=>{
          //     if(![2,3,4,5].includes(cur.ExpId) && cur.IsOwnRcpt === 0){
          //       return prev + cur.Total
          //     } else {
          //       return prev
          //     }
          //   } , 0)
          // }
          // console.log("row" , row)
          let othExp = 0
          let othExpDscps = []
          for (const ex of row.Exps) {
            if ([1, 2, 3, 4, 5].includes(ex.ExpId)) {
              row[`E${ex.ExpId}`] = +ex.Total
            } else {
              othExp += ex.Total
              othExpDscps.push(`${ex.ExpNm}:${ex.Total}`)
            }
          }
          row.OthExp = othExp
          row.OthExpDscp = othExpDscps.join(';')

          let othAmnt = 0
          let othDscps = []
          let sumCost = 0
          for (const pi of row.PCItms) {
            if ([83, 2, 3, 5, 4, 84, 95, 82, 86, 107, 89, 91, 96, 93, 94, 92, 100].includes(pi.ExpId)) {
              if (row[`C${pi.ExpId}`]) {
                row[`C${pi.ExpId}`] += +pi.Amnt
              } else {
                row[`C${pi.ExpId}`] = +pi.Amnt
              }
            } else {
              othAmnt += +pi.Amnt
              othDscps.push(`${pi.ExpNm}:${pi.Amnt}`)
            }
            sumCost += +pi.Amnt
          }
          row.OthAmnt = othAmnt
          row.OthDscp = othDscps.join(";")
          row.SumCost = sumCost
        }
        setDataTable(addIdForDataGrid(value.data, "JobOrdId"))
      }
    })
  }, [ax])

  const setSelectDate = useCallback((st, en) => {
    setFilterData(o => ({ ...o, AptTmSt: st, AptTmEn: en }))
  }, [])

  const setSelectInvDate = useCallback((st, en) => {
    setFilterData(o => ({ ...o, InvDteSt: st, InvDteEn: en }))
  }, [])


  const monthPickerProp = useMemo(() => ({
    openTo: "month",
    views: ["year", "month"],
    disableMaskedInput: true,
    label: "คิดเงินเดือน",
    inputFormat: "MMMM YYYY",
    value: filterData.SalDte,
    onChange: (newValue) => { setFilterData(o => ({ ...o, SalDte: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 160 }} />,

  }), [filterData.SalDte])

  const comboProp = useMemo(() => ({
    options: msData.cusCombo,
    label: "ลูกค้า",
    sx: { width: 130 },
    selectedId: filterData.CusId,
    setSelectedId: (id) => {
      setFilterData(o => ({ ...o, CusId: id }))
      setJobCombo(id ? msData.jobCombo.filter(item => item.refId === id) : msData.jobCombo)
    }
  }), [filterData.CusId, msData.cusCombo, msData.jobCombo])

  const comboPropJob = useMemo(() => ({
    options: jobCombo,
    label: "งาน",
    sx: { width: 130 },
    selectedId: filterData.JobId,
    setSelectedId: (id) => { setFilterData(o => ({ ...o, JobId: id })) }
  }), [filterData.JobId, jobCombo])

  const comboPropDrv = useMemo(() => ({
    options: msData.driverCombo,
    label: "พนักงานขัรถ",
    sx: { width: 130 },
    selectedId: filterData.DrvId,
    setSelectedId: (id) => { setFilterData(o => ({ ...o, DrvId: id })) }
  }), [filterData.DrvId, msData.driverCombo])

  useEffect(() => {
    getData(initFilterData)
  }, [getData])
  return (
    <BoxFC p={2} height="100%">
      <BoxFR>
        <Typography variant="h6">รายละเอียดใบงาน </Typography>
        <Box flex={1} />

        <Box sx={{ position: "relative" }}>
          <DesktopDatePicker {...monthPickerProp} disabled={filterData.IsFilterSalDte ? false : true} />
          <CheckboxFormControl sx={{ position: "absolute", bottom: -24, left: 0 }} label="ระบุุคิดเงินเดือน"
            checked={filterData.IsFilterSalDte === 1}
            onChange={(e) => setFilterData(o => ({ ...o, IsFilterSalDte: e.target.checked ? 1 : 0 }))} />
        </Box>
        <DateTimeSelect
          sx={{ width: 180 }}
          label={jobOrderColNm.AptTm}
          start={filterData.AptTmSt}
          end={filterData.AptTmEn}
          setSelectDate={setSelectDate}
          getData={() => { getData(filterData) }}
        />
        <DateTimeSelect
          sx={{ width: 180 }}
          label={invoiceColNm.InvDte}
          start={filterData.InvDteSt}
          end={filterData.InvDteEn}
          setSelectDate={setSelectInvDate}
          getData={() => { getData(filterData) }}
        />
        <ComboBox {...comboProp} />
        <ComboBox {...comboPropJob} />
        <ComboBox {...comboPropDrv} />
        <TextField size="small" value={filterData.Loc || ""} label="สถานที่" sx={{ width: 150 }}
          onChange={(e) => setFilterData(o => ({ ...o, Loc: e.target.value || null }))} />
        <TextField size="small" value={filterData.JobNo || ""} label="JobNo" sx={{ width: 150 }}
          onChange={(e) => setFilterData(o => ({ ...o, JobNo: e.target.value || null }))} />
        <TextField size="small" value={filterData.ContNo || ""} label="Container No." sx={{ width: 150 }}
          onChange={(e) => setFilterData(o => ({ ...o, ContNo: e.target.value || null }))} />
        <Button variant="contained" onClick={() => getData(filterData)}>
          <SearchRoundedIcon mr={1} /> ค้นหา
        </Button>
        <ClearButton onClick={() => {
          setFilterData({ ...clearFilterData })
          setJobCombo(msData.jobCombo)
        }} />
        {/* <Box flex={1}/>
        <Button variant="contained" onClick={handleShowDialogInv}>จัดเรียงข้อมูล แจ้งหนี้</Button>
        <Button variant="contained" onClick={handleShowDialogBN}>จัดเรียงข้อมูล วางบิล</Button> */}
      </BoxFR>
      <Box width="100%" flexGrow={1} mt={1} >
        <DataGridCellExpand
          disableSelectionOnClick={false}
          hideFooter
          rows={dataTable}
          columns={columns} />
      </Box>
      <DataTableDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        mode={mode}
        dataTable={dialogDataTable} />
    </BoxFC>
  )
}

export default JobOrderAllDetail